import React from 'react';

import Spinner from '@components/Spinner';
import useRecommendedNewsletters from '@hooks/useRecommendedNewsletters';

import NewsletterCards from './NewsletterCards';
import MyTISection from './Section';

const MyTINewsletters = () => {
  const { newsletters, isLoadingNewsletters } = useRecommendedNewsletters();

  if (!isLoadingNewsletters && newsletters?.length === 0) return null;

  return (
    <MyTISection
      highlight="Label"
      subtitle="Lorem ipsum dolor sit amet consectetur adipisicing elit"
      title="Newsletters"
    >
      {!isLoadingNewsletters && newsletters ? (
        <div className="mt-32 flex w-full flex-row flex-wrap justify-center gap-20 md:grid md:grid-cols-4">
          <NewsletterCards newsletters={newsletters} />
        </div>
      ) : (
        <div className="grid w-full place-items-center">
          <Spinner marginY="small" />
        </div>
      )}
    </MyTISection>
  );
};

export default MyTINewsletters;
